export default {
  closeCurrent: '关闭当前标签',
  closeRight: '关闭右侧',
  closeLeft: '关闭左侧',
  closeAll: '关闭全部',
  cannotCloseLast:'这是最后一个标签了, 无法被关闭',
  noLeft:'左侧没有标签',
  noRight:'右侧没有标签'
}
